<template>
  <div class="row mt-4">
    <div class="col">
      <div class="card">
        <div class="card-body">
          <h4 v-if="payment.title !== 'GCash'">{{ payment.title }}</h4>
          <img class="logo" :src="payment.logo" alt="">

          <form id="paymentForm" action="../process_payment.php" method="post" @submit="submit">
            <input type="hidden" name="paymentType" :value="payment.type">

            <!-- INSTALLMENT FORM -->
            <div v-if="payment.hasOwnProperty('terms')" class="row mt-4">
              <div class="col-md-6">
                <div class="form-group row">
                  <label for="ddlPayment" class="col-4 col-form-label">Payment For</label>
                  <div class="col-8">
                    <select class="custom-select form-control" name="ddlPayment" id="ddlPayment">
                      <option v-for="(pmtFor, index) in payment.payments_for" :key="index" :value="pmtFor">{{ pmtFor }}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="txtreferenceno" class="col-4 col-form-label">Reference #</label>
                  <div class="col-8">
                    <input type="text" name="txtreferenceno" id="txtreferenceno" class="form-control" required>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="txtmembername" class="col-4 col-form-label">Member's Name</label>
                  <div class="col-8">
                    <input type="text" name="txtmembername" id="txtmembername" class="form-control" required>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="txtcardholdername" class="col-4 col-form-label">CardHolder's Name</label>
                  <div class="col-8">
                    <input type="text" name="txtcardholdername" id="txtcardholdername" class="form-control" required>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group row">
                  <label for="txtemail" class="col-4 col-form-label">Email Address</label>
                  <div class="col-8">
                    <input type="email" name="txtemail" id="txtemail" class="form-control" required>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="terms" class="col-4 col-form-label">Tenor</label>
                  <div class="col-8">
                    <select class="custom-select form-control" name="terms" id="terms" v-model="selectedTerm" @change="setMinimum(selectedTerm)" required>
                      <option v-for="(term, index) in payment.terms" :key="index" :value="term">{{ term }} Months</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="txtamount" class="col-4 col-form-label">Total Amount</label>
                  <div class="col-8">
                    <input type="number" step="any" name="txtamount" id="txtamount" class="form-control" :min="minimum" required>
                    <sub v-if="minimum > 0" class="min-desc">Minimum amount <strong>{{ formattedMinimum }}</strong></sub>
                  </div>
                </div>
              </div>
            </div>
            <!-- INSTALLMENT FORM END -->

            <!-- ONE TIME PAYMENT FORM -->
            <div v-else class="row mt-4">
              <div class="col-md-6">
                <div class="form-group row">
                  <label for="ddlPayment" class="col-4 col-form-label">Payment For</label>
                  <div class="col-8">
                    <select class="custom-select form-control" name="ddlPayment" id="ddlPayment">
                      <option v-for="(pmtFor, index) in payment.payments_for" :key="index" :value="pmtFor">{{ pmtFor }}</option>
                    </select>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="txtreferenceno" class="col-4 col-form-label">Reference #</label>
                  <div class="col-8">
                    <input type="text" name="txtreferenceno" id="txtreferenceno" class="form-control" required>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="txtmembername" class="col-4 col-form-label">Member's Name</label>
                  <div class="col-8">
                    <input type="text" name="txtmembername" id="txtmembername" class="form-control" required>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group row">
                  <label v-if="payment.type === 'bpi_online_banking'" for="txtcardholdername" class="col-4 col-form-label">Account Name</label>
                  <label v-else for="txtcardholdername" class="col-4 col-form-label">CardHolder's Name</label>
                  <div class="col-8">
                    <input type="text" name="txtcardholdername" id="txtcardholdername" class="form-control" required>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="txtemail" class="col-4 col-form-label">Email Address</label>
                  <div class="col-8">
                    <input type="email" name="txtemail" id="txtemail" class="form-control" required>
                  </div>
                </div>
                <div class="form-group row">
                  <label for="txtamount" class="col-4 col-form-label">Total Amount</label>
                  <div class="col-8">
                    <input type="number" step="any" name="txtamount" id="txtamount" class="form-control" required>
                  </div>
                </div>
              </div>
            </div>
            <!-- ONE TIME PAYMENT FORM END-->
            <div class="row mt-4">
              <div class="col text-center">
                <button type="submit" class="btn btn-lg btn-primary" :disabled="loading">Pay Now <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span></button>
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaymentForm",
  props: {
    payment: Object
  },
  data() {
    return {
      loading: false,
      minimum: 0,
      selectedTerm: null
    }
  },
  computed: {
    formattedMinimum() {
      return this.minimum.toLocaleString('en-PH', {style: 'currency', currency: 'PHP'})
    }
  },
  mounted() {
    this.setMinimum(this.selectedTerm)
  },
  methods: {
    submit() {
      this.loading = true
    },
    setMinimum(term) {
      if (term >= 3 && term <= 6) {
        this.minimum = 30000
      } else if (term === 12) {
        this.minimum = 70000
      } else {
        this.minimum = 0
      }
    }
  }
}
</script>

<style scoped lang="scss">
  #paymentForm .form-group label {
    color: #00979d;
    font-size: 1.1rem;
  }

  .card {
    background-color: #eff0f1;
    border-radius: 20px;
    min-width: 420px;
  }
  .card-body .logo {
    max-height: 80px;
  }

  .btn-primary {
    background-color: #00979d;
    color: white;
  }
  .min-desc {
    color: red;
  }
  @media only screen and (max-width: 425px){
    .card-body .logo {
      max-height: 50px;
    }
  }
</style>